import React from "react"
import "./Intro.css"
import { translate, getLocale } from "./i18n";

const t = translate;

const norwegianIntro = () => {
    return <>
        <p>
            Nowa-kalkulatoren er ment som et hjelpemiddel til beregning av kapitalisert Nowa (Norwegian Overnight Weighted Average) og for å øke forståelsen for hvordan kapitaliserte perioderenter beregnes. Brukeren kan selv spesifisere datoer og hvilke parametere som skal inngå i beregningen. Forklaring på de ulike parameterne finnes i <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/globalassets/upload/markeder/nowa/teknisk-dokumentasjon-nowa-kalkulator.pdf">teknisk dokumentasjon (pdf)</a>.
        </p>

        <p>
            Grunnlaget for beregningene er den daglige Nowa-renten som publiseres av Norges Bank, med historikk tilbake til 2. januar 2020. Norges Bank publiserer også en <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/tema/Statistikk/Rentestatistikk/nowa-indeks/">avkastningsindeks for Nowa (Nowai)</a> og <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/tema/Statistikk/Rentestatistikk/nowa-snitt/">kapitaliserte gjennomsnittsrenter</a>.
        </p>

        <p>
            Formålet med denne kalkulatoren er kun å gi veiledning. Dataene skal ikke refereres til i finansielle kontrakter eller andre bindende avtaler. Norges Bank er ikke ansvarlig for eventuelle feil eller avvik i beregningene.
        </p>
    </>
}

const englishIntro = () => {
    return <>
        <p>
            The Nowa calculator is intended to be an aid in calculating the compounded Nowa (Norwegian Overnight Weighted Average) rate in order to increase the understanding of how the periodic Nowa rate is calculated. The user can specify dates and other parameters to be included in the calculation. An explanation of the parameters is found in the <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/globalassets/upload/markeder/nowa/technical-documentation-nowa-calculator.pdf">technical documentation (pdf)</a>.
        </p>

        <p>
            The calculations are based on the daily Nowa rate as published by Norges Bank, with historical data back to 2 January 2020. Norges Bank also publishes a <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/en/topics/Statistics/Interest-rates/nowa-index/">Nowa compounded index (Nowai)</a> and <a target="_blank" rel="noreferrer" href="https://www.norges-bank.no/en/topics/Statistics/Interest-rates/nowa-average/">compounded Nowa averages</a>.
        </p>

        <p>
            This calculator is intended solely as guidance. The data should not be cited in financial contracts or other binding agreements. Norges Bank is not liable for any errors or discrepancies in the calculations.
        </p>
    </>
}

const Intro: React.FC = () => {
    const content = getLocale() === "nb" ? norwegianIntro() : englishIntro();

    return <>
        <div className="intro">
            <h1>{t("intro.title")}</h1>
            {content}
        </div>
    </>
};

export default Intro;